import { Component, OnInit } from '@angular/core';
import { ScheduleService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.scss'],
  providers:[ScheduleService,MasterService]
})
export class HolidaysComponent implements OnInit {
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arrsch:any=[];
  masocc=[];
  objfilt:any={};
    objsch:any={};
    arrasch:any=[];

  constructor(private http: HttpClient, private sservice: ScheduleService,private mservice:MasterService,private modalService: NgbModal) { }

  open(content) {
    this.modalOptions = {
     
      size:'sm'
     
    }
    this.modalService.open(content, this.modalOptions ).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
 
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {

    this.Bindtable();
    this.Getsel_sp_masoccation();
  }


  Getsel_sp_masoccation()
  {
    debugger
    this.mservice.sel_sp_masoccation()
    .subscribe(
    resultArray =>{
    console.log('result',resultArray) ;
    this.masocc=resultArray;
    
      },
  error => console.log("Error :: " + error)
  )
  }
  Bindtable() {
      debugger
      
      
      this.sservice.sel_sp_schholidaylist()
          .subscribe(resultArray => {
             console.log('ret-select', resultArray);
              this.arrsch = resultArray;
              //alert (resultArray.message);

          }, error =>
              alert('error in connection')
          );
      
  }
 

  opensubject(content,objdata,cmd) {
    debugger
    if(cmd=='insert')
    {
      this.objsch={};
     
      
      //console.log('date',this.sservice.getdatetoday().toString())
      this.objsch.occid=0;
      this.objsch.ayid=0;
      this.objsch.hid=0;
      //this.objsch.subgpId=0;
      this.objsch.holdt1=this.sservice.getdatetoday();
      
      //this.objsubject.subcaId=0;
      // this.objsubcat.subcacd='';
      //this.objsubcat.subcanm='';
      this.objsch.oprtype='insert';
     
    }
  
    else if(cmd=='update')
    {
      this.objsch=objdata;
      this.objsch.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
      
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  SaveDetails() {
    var occid = this.objsch.occid;
    var hodt = this.objsch.holdt1;
    var hid = this.objsch.hid;
    

    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
   // let holdt=this.SchService.converttodate(hodt);
   // var oprtag = "insert"
    var clssubdata = { occid: occid, hodt: hodt, oprtag: this.objsch.oprtype,clcd:clcd,aycd:aycd,ayid:hid };
   // var oprtag = "insert"
    //var clssubdata = { clid: clid, subid: subid, oprtag: this.objsch.oprtype,assid:assid,asstypeid:asstypeid,portion:portion,remarks:remarks,assdt:assdt,clcd:clcd,aycd:aycd };
    
    
   
    console.log('save-model', clssubdata);
    this.sservice.save_sp_schholidaylist(clssubdata)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            if(resultArray.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
             // this.Getsel_sp_massubgp();
             this.Bindtable();
            }
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();
  }

  Deletedetails(objsch) {

    if(confirm("Are you sure? you wan't to delete. "))
    {
    var occid = objsch.occid;
    var hodt = objsch.holdt1;
    

    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
   // let holdt=this.SchService.converttodate(hodt);
   // var oprtag = "insert"
    var clssubdata = { occid: occid, hodt: hodt, oprtag:'delete',clcd:clcd,aycd:aycd,ayid:objsch.hid };
   // var oprtag = "insert"
    //var clssubdata = { clid: clid, subid: subid, oprtag: this.objsch.oprtype,assid:assid,asstypeid:asstypeid,portion:portion,remarks:remarks,assdt:assdt,clcd:clcd,aycd:aycd };
    
    
   
    console.log('save-model', clssubdata);
    this.sservice.save_sp_schholidaylist(clssubdata)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            if(resultArray.status=='success')
            {
              
             this.Bindtable();
            }
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();
  }
}
}
